<i18n>
{
  "fr": {
    "configuratorGlassSettingsColorsSizesRow": {
      "label": "Taille\u00a0:",
      "hypeProduct": "Top\u00a0des ventes",
      "error": {
        "sizeNotAvailable": "Le thème sélectionné n'existe pas dans la taille demandée.\n\nCliquez sur OK pour afficher les autres thèmes disponibles."
      }
    }
  }
}
</i18n>

<template>
  <div class="configurator-glass-settings-sizes-row">
    <span class="configurator-glass-settings-sizes-row__label">
      {{ $t('configuratorGlassSettingsColorsSizesRow.label') }}
    </span>

    <div class="configurator-glass-settings-sizes-row__wrapper">
      <div
        v-for="size of sizes"
        :key="size.id"
        class="configurator-glass-settings-sizes-row__sizes-wrapper"
      >
        <input
          :id="getOptionId(size)"
          type="radio"
          name="size"
          :value="size.id"
          :checked="value === size.id"
          class="configurator-glass-settings-sizes-row__input option-picker__input"
          @change="onChange"
        />
        <label
          :for="getOptionId(size)"
          class="configurator-glass-settings-sizes-row__size-label option-picker__label"
        >
          <span
            :class="[
              'configurator-glass-settings-sizes-row__option',
              activeSizeId === size.id &&
                'configurator-glass-settings-sizes-row__option--active',
              isHypeProduct(size) &&
                'configurator-glass-settings-sizes-row__option--hype',
            ]"
          >
            <span
              :title="size.name"
              :class="[
                'configurator-glass-settings-sizes-row__option-preview',
                'icon',
                size.icon && `icon--${size.icon}`,
              ]"
            ></span>
            <span class="configurator-glass-settings-sizes-row__option-label">
              {{ size.name }}
            </span>
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ConfiguratorAction,
  prefixType as prefixConfiguratorType,
} from '../../../store/modules/configurator';
import { ucFirst } from '../../../utils/String';
import {
  GlassesGetter,
  mapGetters as mapGlassesGetters,
} from '../../../store/modules/configurator/glasses';
import { SizeIdNotAvailableError } from '../../../utils/ConfiguratorModuleUtils';
import { SizeId } from '../../../api/static/sizes';

export default {
  name: 'ConfiguratorGlassSettingsSizesRow',
  computed: {
    ...mapGlassesGetters({
      sizes: GlassesGetter.GET_SIZES,
    }),
    activeSizeId: {
      get() {
        return this.$store.state.configurator.activeSizeId;
      },
      set(sizeId) {
        try {
          this.$store.dispatch(
            prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
            { sizeId, fallbackWhenNotFound: false }
          );
        } catch (e) {
          if (
            e instanceof SizeIdNotAvailableError &&
            confirm(
              this.$t(
                'configuratorGlassSettingsColorsSizesRow.error.sizeNotAvailable'
              )
            )
          ) {
            this.$store.dispatch(
              prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
              { sizeId, fallbackWhenNotFound: true }
            );
          }
        }
      },
    },
    value() {
      return '';
    },
  },
  methods: {
    ucFirst,
    getOptionId(size) {
      return `configurator-glass-settings-sizes-row__size--${size.name}--${size.id}`;
    },
    onChange(e) {
      this.activeSizeId = Number.parseInt(e.target.value, 10);
    },
    isHypeProduct(size) {
      return size.id === SizeId.G25;
    },
  },
};
</script>

<style scoped lang="scss">
.configurator-glass-settings-sizes-row {
  $base-selector: &;
  $option-width: 3em;

  display: flex;
  align-items: center;
  padding: $configurator-personalization-section-padding;

  &:last-child {
    padding-bottom: 0;
  }

  &__label {
    margin-right: 0.5em;

    @include breakpoint($breakpoint-l) {
      margin-right: 1em;
    }
  }

  &__wrapper {
    display: flex;
    overflow-y: auto;
    flex: 1;
    min-width: 0;
  }

  &__sizes-wrapper {
    margin-right: 0.5em;
    flex: 0 1 $option-width;
    min-width: 2.5rem;

    @include breakpoint($breakpoint-configurator-l) {
      flex-basis: 6.5em;
    }

    &:last-child {
      margin-right: 0;
    }

    &:focus-within {
      #{$base-selector} {
        &__option {
          border-color: $color-primary;
        }
      }
    }
  }

  &__size-label {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  &__option {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: $configurator-wrapper-border-radius;
    width: 100%;
    transition-property: color, background, border;
    transition-duration: $default-transition-duration;
    padding: 0.5rem 0 0;
    // Border for focus state
    border: 2px solid transparent;
    color: $color-primary;

    &:focus,
    &:hover {
      border-color: $color-primary;
    }

    &--active {
      border-color: $color-secondary;
      background-color: $color-gray-wild-sand;
    }
  }

  &__option-preview {
    font-size: 1.75em;

    @include breakpoint($breakpoint-configurator-l) {
      font-size: 2.5em;
    }
  }

  &__option-label {
    font-size: 0.625em;
    font-weight: 600;
    height: 2.2em;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    line-height: 0.9375rem;

    @include breakpoint($breakpoint-configurator-l) {
      font-size: 0.8125em;
    }
  }

  &__hype {
    text-transform: none;
    display: inline-block;
    border: 1px solid $color-primary;
    color: $color-primary;
    font-size: 0.7em;
    border-radius: 0 0 0.2em 0.2em;
    width: 100%;
    font-weight: bold;
    padding: 0.25em;
    text-align: center;
  }
}
</style>
